<div #errorModal>
    <div class="trpx-group-modal-body" [ngClass]="getModalClass()">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="modal_spacing" [ngClass]="{ 'modal_spacing_success': modalColor === 'success' }">
                        <button *ngIf="modalColor === 'success'" type="button" class="btn-close close"
                            aria-label="Close" (click)="close()">
                            <span aria-hidden="true" class="visually-hidden">&times;</span>
                        </button>

                        <div class="position-relative text-center">
                            <div class="img_icon text-center" *ngIf="modalColor === 'success'">
                                <img src="./assets/icons/check-contact.svg" alt="">
                            </div>
                            <div class="img_icon text-center" *ngIf="modalColor === 'error'">
                                <svg width="77" height="77" viewBox="0 0 77 77" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="38.5" cy="38.5" r="38.5" fill="#ff2742" fill-opacity="0.1" />
                                    <g clip-path="url(#clip0_2457_9456)">
                                        <path
                                            d="M41.3223 38.5252L53.3154 26.5319C54.0958 25.7518 54.0958 24.4904 53.3154 23.7103C52.5353 22.9302 51.2739 22.9302 50.4938 23.7103L38.5004 35.7035L26.5075 23.7103C25.727 22.9302 24.4661 22.9302 23.686 23.7103C22.9055 24.4905 22.9055 25.7518 23.686 26.5319L35.6788 38.5252L23.6861 50.5184C22.9056 51.2985 22.9056 52.5599 23.6861 53.34C23.8711 53.5255 24.091 53.6727 24.3331 53.773C24.5752 53.8734 24.8348 53.9249 25.0968 53.9246C25.6076 53.9246 26.1185 53.7291 26.5076 53.34L38.5004 41.3468L50.4938 53.34C50.6789 53.5255 50.8988 53.6727 51.1409 53.773C51.383 53.8733 51.6425 53.9248 51.9046 53.9246C52.4153 53.9246 52.9263 53.7291 53.3154 53.34C54.0958 52.5598 54.0958 51.2985 53.3154 50.5184L41.3223 38.5252Z"
                                            fill="#ff2742" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_2457_9456">
                                            <rect width="30.8" height="30.8" fill="white"
                                                transform="translate(23.0996 23.1)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div class="img_icon text-center" *ngIf="modalColor === 'warning'">
                                <svg width="80" height="80" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" r="12" fill="#faa633" fill-opacity="0.1" />
                                    <path
                                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 15h-1v-1h1v1zm0-3h-1V7h1v7z"
                                        fill="#faa633" />
                                </svg>

                            </div>
                            <div class="heading_data">
                                {{headData}}
                            </div>
                            <div class="description_data">
                                {{subHeadData}}
                            </div>
                            <div class="loader-container" *ngIf="autoClose">
                                <div class="loader-line"></div>
                                <!-- <p class="remaining-time">{{ remainingTime }}s remaining</p> -->
                            </div>
                        </div>
                        <!-- <div class="loader-line" *ngIf="this.autoClose"></div> -->
                        <div *ngIf="modalColor === 'warning' || modalColor === 'error'">
                            <div class="trpx-group-modal-footer">
                                <button type="button" class="btn" data-dismiss="modal"
                                    (click)="close()">Confirm</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>